
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M.5 34.8h36.48M4.19 35.43S7 54 13.11 54h33.78c6.14 0 8.92-18.6 8.92-18.6M46.98 34.8H59.5M13.78 53.74v5.71M46.23 53.74v5.71M25.17 6.93a8.67 8.67 0 00-16.69 3.28v23.86"}}),_c('path',{attrs:{"d":"M34 14.22a7.5 7.5 0 10-15 0z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"26.48","cy":"20.82","r":"1.5","fill":"#241f21"}}),_c('circle',{attrs:{"cx":"31.01","cy":"27.98","r":"1.5","fill":"#241f21"}}),_c('circle',{attrs:{"cx":"21.95","cy":"27.98","r":"1.5","fill":"#241f21"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M36.98 31.72h10v15h-10zM37.4 41.13h9.44"}})])
          )
        }
      }
    